import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIconBlue from "../img/svg/close_blue_new_design.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function ConfirmPopup({
  isOpen,
  setIsOpen,
  headerTextTop,
  headerTextBottom,
  headerTextSubBottom,
  bodySubText,
  btnText,
  handleClose,
  onConfirm,
  marginB = "20px",
}) {
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{ p: 0 }}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <Box>
        <DialogTitle
          sx={{
            m: 0,
            // pt: 7,
            pb: 0,
            display: "flex",
            justifyContent: "space-between",
            gap: "5px",
            textAlign: "center",
            mb: marginB,
            alignItems: "baseline",
          }}
          id="customized-dialog-title"
        >
          <img
            src={CloseIconBlue}
            alt="close"
            onClick={handleClose}
            //  style={{marginTop: "10px"}}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              // alignItems: 'baseline'
            }}
          >
            <Typography
              className="open-sans-hebrew"
              gutterBottom
              sx={{
                fontSize: "24px",
                m: 0,
                color: "var(--darkblue)",
                fontWeight: 700,
                textAlign: "center",
                direction: "rtl",
                fontFamily: `var(--font-family) !important`,
              }}
            >
              {headerTextTop}
            </Typography>
            <Typography
              gutterBottom
              className="open-sans-hebrew"
              sx={{
                fontSize: "24px",
                m: 0,
                color: "var(--darkblue)",
                fontWeight: 700,
                textAlign: "center",
                direction: "rtl",
                fontFamily: `var(--font-family) !important`,
              }}
            >
              {headerTextBottom}
            </Typography>
            <Typography
              gutterBottom
              className="open-sans-hebrew"
              sx={{
                fontSize: "24px",
                m: 0,
                color: "var(--darkblue)",
                fontWeight: 700,
                textAlign: "center",
                direction: "rtl",
                fontFamily: `var(--font-family) !important`,
              }}
            >
              {headerTextSubBottom}
            </Typography>
            <Typography
              gutterBottom
              className="open-sans-hebrew"
              sx={{
                fontSize: "18px",
                m: 0,
                textAlign: "right",
                direction: "rtl",
                color: "#1E1E1E",
                mt: "5px",
                fontFamily: `var(--font-family) !important`,
                fontWeight: 400,
              }}
            >
              {bodySubText}
            </Typography>
          </div>
        </DialogTitle>

        <DialogContent
          sx={{
            direction: "rtl",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          {/* <div className="img-container confirm-popup-img">
            <img src={Dumbells} alt="" />
          </div> */}
        </DialogContent>
        <DialogActions sx={{ p: 0, m: "0px" }}>
          <Button
            style={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
            }}
            variant="contained"
            className="phone-dialog-btn phone-dialog-darkblue-btn w-100-percents open-sans-hebrew"
            onClick={onConfirm ?? handleClose}
          >
            {btnText}
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
}
